class HomePageGrid {
  constructor(element) {
    if (!(element instanceof HTMLElement)) {
      throw new TypeError('Invalid element');
    }

    this.element = element;
    this.grid = this.element.querySelector('[data-grid]');
    this.items = JSON.parse(element.dataset.items ?? '[]');

    this.init();
  }

  async init() {
    const formData = new FormData();
    formData.append('action', 'home_page_grid');
    formData.append('items', JSON.stringify(this.items));

    try {
      const response = await fetch('/wp-admin/admin-ajax.php', {
        method: "POST",
        body: formData,
      });

      if (!response.ok) {
        throw new Error(`Response status: ${response.status}`);
      }

      const formattedItems = await response.json();

      if(formattedItems && formattedItems.length > 0){
        this.grid.innerHTML = '';

        formattedItems.forEach((item) => {
          const parsedSpinner = new DOMParser().parseFromString(
            `
                <div class="${item.colClass}">
                    <a
                        href="${item.permalink ?? '#'}"
                        class="${item.itemClass ?? ''}"
                        style="background-color: ${item.colour ?? 'transparent'}"
                    >
                        ${item.imageHTML ?? ""}
                        <div class="tile__content">
                            <h4 class="tile__title">${item.title ?? ""}</h4>
                        </div>
                    </a>
                </div>
            `,
            'text/html',
          );

          const el = parsedSpinner.body.firstChild;
          this.grid.insertAdjacentElement("afterbegin", el);
        });
      }
    } catch (error) {
      console.error(error.message);
    }
  }
}

export default HomePageGrid;
